import { omdApi } from 'bus/api';

import { TransportItemFull, TransportType } from './types';

const transportApi = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransportDetail: builder.query<TransportItemFull, { id: number | string }>({
      query: ({ id }) => ({
        url: `/v1/Transport/${id}/details`,
      }),
    }),

    getTransportContractor: builder.query<TransportItemFull, { id: number | string }>({
      query: ({ id }) => ({
        url: `/v1/Transport/${id}`,
      }),
    }),

    getTransportTypes: builder.query<TransportType[], void>({
      query: () => ({
        url: '/v1/Transport/types',
      }),
    }),

    createTransport: builder.mutation<void, TransportItemFull>({
      query: (data) => ({
        url: '/v1/Transport',
        method: 'POST',
        body: data,
      }),
    }),

    editTransport: builder.mutation<void, TransportItemFull>({
      query: (data) => ({
        url: `/v1/Transport/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),

    deleteTransport: builder.mutation<void, { id: number | string }>({
      query: ({ id }) => ({
        url: `/v1/Transport/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetTransportDetailQuery,
  useLazyGetTransportDetailQuery,
  useGetTransportContractorQuery,
  useLazyGetTransportContractorQuery,
  useGetTransportTypesQuery,
  useLazyGetTransportTypesQuery,
  useCreateTransportMutation,
  useEditTransportMutation,
  useDeleteTransportMutation,
} = transportApi;
